import React, { useState } from 'react';
import Modal from "../../../../components/Modal/Modal";

const ImportacionImagenes = () => {
  const [statusModal, setModalStatus] = useState(true);
  const [datosModal, setDatosModal] = useState("");
  return (
    <> 
    <Modal
      datos={datosModal}
      isOpen={statusModal}
      onClose={() => setModalStatus(false)}
      type={"importacionImagenes"}
    />
    </>
  )
}

export default ImportacionImagenes